module.exports = __webpack_public_path__ + "media/application/images/2023-27001-46a1662c992b1a171d0b0a2702ea9379.jpg";